<div class="dispatch-forecast-component">
  <dr-flex-home-ui-widget-header [title]="('FLEX_HOME.DISPATCH_FORECAST_WIDGET.TITLE' | translate)"></dr-flex-home-ui-widget-header>
  @if(forecastData() === null){
    <div class="loading-spinner">
      <dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
    </div>
  }
  @else {
  <div class="dispatch-forecast-component__top-row">
    @if(selectedForecast().length) {
    <div class="dispatch-forecast-component__description">{{ 'FLEX_HOME.DISPATCH_FORECAST_WIDGET.DESCRIPTION' | translate }}</div>}
    <div class = "dispatch-forecast-component__program_selector">
    <div class="drop-down">
      <dsy-input-dropdown
      label =  "{{ 'FLEX_HOME.DISPATCH_FORECAST_WIDGET.PROGRAM' | translate }}" 
      density="wide"
      [entries]="programs()"
      [customDsyListConfObject]="dropDownListConfig()"
      [counterTagConfig]="dropDownTagConfig"
      >
      </dsy-input-dropdown>
    </div>
    </div>
  </div>
    @if(selectedForecast().length) {
    <div class="dispatch-forecast-component__event-row">
      <div class="dispatch-forecast-component__event">{{ 'FLEX_HOME.DISPATCH_FORECAST_WIDGET.EVENT' | translate }}
        <div class="dispatch-forecast-component__icon">
        <dsy-icon
          name="info"
          size="0.8rem"
          [pTooltip]="
          ('FLEX_HOME.DISPATCH_FORECAST_WIDGET.INDICATOR' | translate) + 
            (auditForecast ? ('FLEX_HOME.DISPATCH_FORECAST_WIDGET.AUDIT_INDICATOR' | translate) : '')"

          tooltipPosition="bottom"
          [escape]="false">
        </dsy-icon>
      </div>
      </div>
      @if (auditWindowRange; as audit){
        <span class="dispatch-forecast-component__audit">
            {{ 'FLEX_HOME.DISPATCH_FORECAST_WIDGET.AUDIT_WINDOW' | translate }}  
            <div class = "auditDateRange">
            {{ audit.start| dispatchForecastDate:locale() }}
                -
            {{ audit.end | dispatchForecastDate:locale() }}
          </div>
        </span>
        
      }@else {
      <div class="dispatch-forecast-component__average"> {{ 'FLEX_HOME.DISPATCH_FORECAST_WIDGET.AVERAGE' | translate }}  
        @if (averageLikelihood(); as avg) {
          <dsy-card  class="dispatch-forecast-component__status-card" [class]="'status--' + avg.toLowerCase()">
            <span class="status-text">
            {{ ('FLEX_HOME.DISPATCH_FORECAST_WIDGET.TYPE.' + avg) | translate }}
            </span>
          </dsy-card>
        }
      </div>
      }
    </div>
    <div class="dispatch-forecast-component__dispatchDates">
      <div class="dispatch-forecast-component__columns">
        @for (forecast of selectedForecast(); track forecast.date) {
          <div
          class="forecast-column"
          [class.today]="isToday(forecast.date)"
          [class.past]="isPast(forecast.date)"
          >
            <div class="day-cell">
              {{ forecast.date | date:'ccc':undefined:locale() }}
            </div>

            <div class="date-cell">
              {{ forecast.date | dispatchForecastDate:locale() }}
            </div>
          </div>
        }
      </div>
    </div>

    <dsy-card class="dispatch-forecast-component__dispatch_forecast-card" card-color="#fff" height="12.31rem" width="76rem" custom-style="border-radius: 1.25rem;padding:0.5rem" is-round-border="true" has-border="true">
      <div class="dispatch-forecast-component__likelihood-row">
        @for (forecast of selectedForecast(); track forecast.date) {
          <div class="dispatch-forecast-component__dispatch_forecast-column" [class.past]="isPast(forecast.date)" >
            @if(forecast.isAuditWindow){
              <dsy-card class="dispatch-forecast-component__audit-card">
                <span class="status-text">
                  {{ ('FLEX_HOME.DISPATCH_FORECAST_WIDGET.TYPE.AUDIT') | translate }}
                </span>
              </dsy-card>
            }
            @if(forecast.isHoliday){
              <dsy-card
            class="dispatch-forecast-component__likelihood-card"
            [class]="'status--na'">
              <span class="status-text">
              {{ ('FLEX_HOME.DISPATCH_FORECAST_WIDGET.TYPE.HOLIDAY') | translate }}
              </span>
            </dsy-card>
            }@else{
            <dsy-card
            class="dispatch-forecast-component__likelihood-card"
            [class]="'status--' + forecast.likelihood.toLowerCase()">
              <span class="status-text">
              {{ ('FLEX_HOME.DISPATCH_FORECAST_WIDGET.TYPE.' + forecast.likelihood) | translate }}
              </span>
            </dsy-card>
            }
          </div>
        }

      </div>
    </dsy-card>
      @if(auditForecast?.auditText; as auditText){
        <dsy-card class="dispatch-forecast-component_audit_window_message" >
          <div class="audit_window-row"> 
          <div class="audit-icon">
            <dsy-icon
              name="info-icon"
              size="1.3rem"> 
            </dsy-icon>
          </div>
          <div class="audit_text">
            {{ auditText|  slice:0:100 }}
          </div>
        </div>
        </dsy-card>
      }
    }@else {
      <div class="empty" >
        <dr-flex-home-ui-empty-state [showPermissionStatus]="true" [title]="'FLEX_HOME.DISPATCH_FORECAST_WIDGET.NO_DATA'"></dr-flex-home-ui-empty-state>
      </div>
  }

}

</div>
